import {createContext, useState, useMemo} from 'react';
import * as React from 'react';

export type SearchFilter = {
  key: 'locale' | 'resource_type';
  value: string[];
} | null;

export interface TranslatableResourceSearchContextType {
  query: string;
  localeFilter: SearchFilter;
  resourceTypeFilter: SearchFilter;
  isActive: boolean;
  selected?: string[];
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  setLocaleFilter: React.Dispatch<React.SetStateAction<SearchFilter>>;
  setResourceTypeFilter: React.Dispatch<React.SetStateAction<SearchFilter>>;
  toggleSearch: (isActive: boolean) => void;
  setSelected: (selected?: string[]) => void;
}

export const TranslatableResourceSearchContext =
  createContext<TranslatableResourceSearchContextType>({
    query: '',
    localeFilter: null,
    resourceTypeFilter: null,
    isActive: false,
    selected: undefined,
    setQuery: () => {},
    setLocaleFilter: () => {},
    setResourceTypeFilter: () => {},
    toggleSearch: () => {},
    setSelected: () => {},
  });

export function TranslatableResourceSearchProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isActive, setIsActive] = useState(false);
  const [selected, setSelected] = useState<string[]>();
  const [query, setQuery] = useState<string>('');
  const [localeFilter, setLocaleFilter] = useState<SearchFilter>(null);
  const [resourceTypeFilter, setResourceTypeFilter] =
    useState<SearchFilter>(null);

  const toggleSearch = (isActive: boolean) => {
    setIsActive(isActive);
  };

  const contextValue = useMemo(
    () => ({
      query,
      setQuery,
      localeFilter,
      setLocaleFilter,
      resourceTypeFilter,
      setResourceTypeFilter,
      isActive,
      toggleSearch,
      selected,
      setSelected,
    }),
    [isActive, localeFilter, query, resourceTypeFilter, selected],
  );

  return (
    <TranslatableResourceSearchContext.Provider value={contextValue}>
      {children}
    </TranslatableResourceSearchContext.Provider>
  );
}
